import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { MentationAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { ActionAlertComponent } from '../../action-alert/action-alert.component';

interface MentationActionFormGroup {
	mentationScore: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-mentation-action-controls',
    templateUrl: './mentation-action-controls.component.html',
    styleUrls: ['../../../common.scss', './mentation-action-controls.component.scss'],
    imports: [CommonActionControlsComponent, ActionFormComponent, UnitQuantityControl, ReactiveFormsModule, ActionAlertComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MentationActionControlsComponent implements SheetActionControlsBase {

	slot!: Slot | null;
	action!: MentationAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as MentationAction;
	}

	@Input() form!: FormGroup<MentationActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

  	ngOnInit(): void {
      	this.form.addControl('mentationScore', this.formBuilder.control(this.action?.mentationScore ?? null));
  	}
}
